module.exports = __webpack_public_path__ + "img/39-lrn-spt-logo-190.d00ff2dc.svg";